class BudgetRange extends HTMLElement {
	connectedCallback() {
		this.minimum = parseInt(this.dataset.min) || 50;
		this.maximum = parseInt(this.dataset.max) || 250;
		this.step = parseInt(this.dataset.step) || 25;
		this.unset = this.maximum + this.step;
		this.unsetString = this.dataset.unsetString || 'max';

		this.rangeEl = this.querySelector('.budget-range__slider');
		this.displayMinEl = this.querySelector('.budget-range__display-min');
		this.displayMaxEl = this.querySelector('.budget-range__display-max');
		// wait for vendor scripts to load
		setTimeout(() => {
			this.setMinAndMax();
			this._createSlider();
		}, 1000);
	}

	get value() {
		return this.range.get() === this.unsetString ? Infinity : parseFloat(this.range.get());
	}
	setMinAndMax() {
		if (this.displayMinEl) {
			this.displayMinEl.innerHTML = this._formatMoney(this.minimum);
		}
		if (this.displayMaxEl) {
			this.displayMaxEl.innerHTML = this.unsetString;
		}
	}

	_createSlider() {
		this.range = noUiSlider.create(this.rangeEl, {
			connect: 'lower',
			start: this.unset,
			step: this.step,
			range: {
				min: this.minimum,
				max: this.unset,
			},
			tooltips: {
				to: (value) => {
					if (value > this.maximum) return '';
					return this._formatMoney(Math.round(value));
				},
			},
			format: {
				to: (value) => {
					if (value > this.maximum) return this.unsetString;
					return Math.round(value);
				},
				from: (value) => {
					if (value === this.unsetString) return this.unset;
					return Number(value);
				},
			},
		});
	}
	_formatMoney(value) {
		return theme?.Currency?.formatMoney(value, theme?.settings?.moneyFormat);
	}
}
customElements.define('budget-range', BudgetRange);
